<template>
	<el-dialog
		class="wx_relative_dialog"
		:visible.sync="visible"
		width="92%"
		top="4vh"
		title="厂家直采关联"
		append-to-body
		@close="onClose"
	>
		<connect-box
			v-if="visible"
			ref="connectBox"
			@close="close"
			@saved="onSaved"
		/>
	</el-dialog>
</template>

<script>
import connectBox from './connect_box.vue'

export default {
	name: 'WxAlibabaGoodsConnect',
	components: { connectBox },
	data() {
		return {
			visible: false,
		}
	},
	methods: {
		/**
		 * @param {{ order_product_id:number, shop_id?:string, wx_product_id?:number|string, wx_sku_id?:number|string }} payload
		 */
		open(payload) {
			this.visible = true
			this.$nextTick(() => {
				if (this.$refs.connectBox) {
					this.$refs.connectBox.init(payload || {})
				}
			})
		},
		close() {
			this.visible = false
		},
		onClose() {
			if (this.$refs.connectBox) {
				this.$refs.connectBox.reset()
			}
		},
		onSaved() {
			this.visible = false
			this.$emit('saved')
		},
	},
}
</script>

<style scoped>
.wx_relative_dialog >>> .el-dialog__body {
	padding: 10px 16px 16px;
}
</style>
